import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { CabsandTimesheetCreatePage } from './cabsand-timesheet-create';

@NgModule({
  declarations: [
    CabsandTimesheetCreatePage,
  ],
  imports: [
    IonicPageModule.forChild(CabsandTimesheetCreatePage),
  ],
})
export class CabsandTimesheetCreatePageModule {}



// WEBPACK FOOTER //
// ./src/pages/cabsand-timesheet-create/cabsand-timesheet-create.module.ts